"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _default = function _default() {
  let prefix = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  return [_react.default.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.9803 3.1953C9.578 2.3064 10.6441 2 11.9971 2c1.3238 0 2.3672.315 2.9713 1.181.1787.2561.297.5359.3753.819H20v8h-2V6h-2.5023l.0027 2H8.4971V6H6v14h5v2H4V4h4.6277c.0685-.267.177-.5432.3526-.8047zm1.5481 1.5017c-.0297.2327-.0313.5042-.0313.8744V6h3.0006l-.0006-.4286c0-.7727-.0541-1.0814-.169-1.2461-.045-.0646-.2517-.3253-1.331-.3253-1.1451 0-1.3288.2693-1.3568.311-.0367.0545-.0832.161-.1119.386z"
  }), _react.default.createElement("path", {
    d: "M22.4316 14.4608 20.9908 13l-5.9955 6.0784-3.1228-3.166-1.4409 1.4608L14.9953 22l7.4363-7.5392z"
  })];
};

exports.default = _default;